import { render, staticRenderFns } from "./addRelationshipByCode.vue?vue&type=template&id=153911e8&scoped=true"
import script from "./addRelationshipByCode.vue?vue&type=script&lang=js"
export * from "./addRelationshipByCode.vue?vue&type=script&lang=js"
import style0 from "./addRelationshipByCode.vue?vue&type=style&index=0&id=153911e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153911e8",
  null
  
)

export default component.exports